/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {TimeSliderContainer} from '@ion/dls/src/maps/components/TimeSlider';
import {Timeline} from '../tools/TimeSliderTool';
import {MapToolPositions} from '../types/types';
import {addComponent, removeComponent} from './simpleMapUtils';

type TimeSliderTriggerProps = {
  map: __esri.Map;
  view: __esri.MapView;
  timeline: Timeline;
  timeSliderDisabled: boolean;
  assetsHistory: any[];
};

export const timeSliderTrigger = ({
  map,
  view,
  timeline,
  timeSliderDisabled,
  assetsHistory
}: TimeSliderTriggerProps) => {
  view.ui.empty(MapToolPositions.topLeft);
  if (timeline?.isTimeSliderOn && !timeSliderDisabled) {
    addComponent({
      id        : 'time-slider-container',
      position  : MapToolPositions.topLeft,
      component : (
        <TimeSliderContainer map={map}
          view={view}
          timeline={timeline}
          assetsHistory={assetsHistory}/>
      ),
      view
    });
  } else {
    removeComponent('time-slider-container', view);
  }
};
